



















import { Section } from '@ajax/vue/components/templates/item-list/condition/contactlens/interaction/interaction'
import { Condition } from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'
import ColorButtonView from '@ajax/vue/components/templates/item-list/condition/contactlens/view/section/condition/ColorButtonView.vue'
import TextButtonView from '@ajax/vue/components/templates/item-list/condition/contactlens/view/section/condition/TextButtonView.vue'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'
import { caption } from './assets'

export interface ClickEvent {
  readonly condition: Condition
  readonly section: Section
}

@Component
export default class ConditionSection extends Vue {
  @Prop({ required: true })
  readonly section: Section

  get captionIconPath(): string {
    switch (this.section.name) {
      case 'disposalSchedule': return caption('wear_period.png')
      case 'dia':
      case 'colorDia':
        return caption('dia.png')
      case 'color': return caption('color.png')
      case 'prescriptionOrNot': return caption('lens_power.png')
      case 'bc': return caption('base_curve.png')
      case 'withBorderOrNot': return caption('lens.png')
      case 'liquidRetainedRatio': return caption('liquid_rate.png')
      case 'option': return caption('option.png')
    }
  }

  get conditionView() {
    return this.section.name === 'color' ? ColorButtonView : TextButtonView
  }

  get label(): string {
    return this.section.conditionGroup.label
  }

  @Emit('click')
  onClick(condition: Condition): ClickEvent {
    return { condition, section: this.section }
  }
}
